import React, { useState, useEffect } from 'react'
import { Button, CheckBox, Modal } from '@st-operations/uikit/src/v2'

import MultiValueInput from '../multi-value-input'
import { useEventFeedsContext } from '../../pages/event-feeds/context'
import { updateEventFeed } from '_services/data-explorer'

import './styles.scss'

const FLATTENER_V2_OPTIONS = [
  'ios_id',
  'android_id',
  'hem_md5',
  'hem_sha1',
  'hem_sha256',
  'id5_uuid',
  'ttd_uuid',
  'mapping_ids',
  'keywords',
  'entities',
  'categories',
  'concepts',
  'iabCategories',
  'metadata',
]

const NESTED_METADATA_OPTIONS = [
  'meta_charset',
  'meta_datalocale',
  'meta_lang_US',
  'meta_lang_En',
  'meta_lang_ka',
  'meta_lang_fr',
  'meta_lang_pl',
  'meta_lang_nl',
  'meta_lang_en-us',
  'meta_lang_English',
  'meta_lang_es',
  'meta_url',
  'meta_title_og',
  'meta_image_secure_url',
  'meta_image_url',
  'meta_description',
  'meta_language',
  'meta_url_og',
  'meta_sitename_og',
  'meta_keywords',
  'meta_article',
  'meta_news_keywords',
  'meta_description_itemprop',
  'meta_card_twitter',
  'meta_title_twitter',
  'meta_image',
  'meta_description_og',
  'meta_description_twitter',
  'meta_site_twitter',
  'meta_locale_og',
  'meta_keywords_og',
  'meta_lang_en',
  'meta_author',
  'meta_datalocale_ES',
  'meta_datalocale_FR',
  'meta_author_itemprop',
  'meta_headline',
  'meta_thumbnailUrl',
  'meta_title',
  'meta_url_twitter',
  'meta_type_og',
  'meta_type_twitter',
]

const EnhancersModal = ({ isOpen, onClose }) => {
  const [extractionIds, setExtractionIds] = useState([])
  const [flattenerv2Ids, setFlattenerv2Ids] = useState([])
  const [nestedMetadataFields, setNestedMetadataFields] = useState([])
  const [phoneModelEnabled, setPhoneModelEnabled] = useState(false)
  const [phoneModelFilterEmpty, setPhoneModelFilterEmpty] = useState(false)

  const { id, data, schema, dispatch, ACTIONS } = useEventFeedsContext()

  const flattenerV2Options = FLATTENER_V2_OPTIONS.filter((option) =>
    data.attributes.includes(option)
  ).map((value) => ({
    label: value,
    value,
  }))

  useEffect(() => {
    setExtractionIds(data.idExtraction)
    setFlattenerv2Ids(data.flatten?.fields || [])
    setNestedMetadataFields(data.nestedMetadata?.fields || [])
    setPhoneModelEnabled(data.phoneModel?.enabled)
    setPhoneModelFilterEmpty(data.phoneModel?.filterEmptyPhoneModel)
  }, [data])

  const handleSave = async () => {
    const newData = {
      ...data,
    }

    newData.idExtraction = extractionIds

    if (flattenerv2Ids?.length > 0) {
      newData.flatten = { fields: flattenerv2Ids }
    } else {
      newData.flatten = null
    }

    if (nestedMetadataFields?.length > 0) {
      newData.nestedMetadata = { fields: nestedMetadataFields }
    } else {
      newData.nestedMetadata = null
    }

    if (phoneModelEnabled) {
      newData.phoneModel = { enabled: true, filterEmptyPhoneModel: phoneModelFilterEmpty }
    } else {
      newData.phoneModel = null
    }

    const response = id !== 'discovery' ? await updateEventFeed(id, newData) : newData
    dispatch({ type: ACTIONS.SET_DATA, payload: response })
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div title="Enhancers">
        <MultiValueInput
          className="enhancers__input"
          label="ID Extraction"
          values={extractionIds}
          options={schema?.id_extraction?.enum.map((value) => ({
            label: value,
            value,
          }))}
          onChange={(value) => setExtractionIds(value)}
        />
        <MultiValueInput
          className="enhancers__input"
          label="Flattener V2"
          values={flattenerv2Ids}
          options={flattenerV2Options}
          onChange={(value) => setFlattenerv2Ids(value)}
        />
        <If condition={flattenerV2Options.length === 0}>
          <div className="text-sm text-left -mt-3 mb-2 text-gray-500">
            You need to have at least one valid attribute selected in youe feed
          </div>
        </If>
        <MultiValueInput
          className="enhancers__input"
          label="Nested Metadata"
          values={nestedMetadataFields}
          options={NESTED_METADATA_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
          onChange={(value) => setNestedMetadataFields(value)}
        />
        <div className="flex flex-col gap-1.5 items-start mb-5">
          <label className="text-[14px] text-gray-700">Phone Model</label>
          <div className="flex flex-row gap-4 text-gray-700 border border-solid border-gray rounded-sm p-5 w-full">
            <CheckBox
              label="Enable Enhancer"
              checked={phoneModelEnabled}
              onChange={(e) => setPhoneModelEnabled(e.target.checked)}
            />
            <CheckBox
              label="Filter Empty Phone Model"
              checked={phoneModelEnabled && phoneModelFilterEmpty}
              disabled={!phoneModelEnabled}
              onChange={(e) => setPhoneModelFilterEmpty(e.target.checked)}
            />
          </div>
        </div>
        <Button onClick={handleSave}>Save</Button>
      </div>
    </Modal>
  )
}

export default EnhancersModal
